import { GetCookieValue, SetCookieExpMS, RemoveCookie } from "@utils";

export const GetSsApiJwtToken = () => {
	if (_.config.Item("SsApiJwt") && _.config.Item("SsApiJwt") != "") {
		return _.config.Item("SsApiJwt");
	}

	if (window.localStorage) {
		var token = localStorage.getItem("SsApiJwt");
		if (token && token != "") {
			return token;
		}
	}

	let cookieValue = GetCookieValue("SsApiJwt");
	if (cookieValue && cookieValue != "") {
		return cookieValue;
	}

	return "";
};
export const SetSsApiJwtToken = (token, expireMS) => {
	if (token && token != "") {
		_.config.Item("SsApiJwt", token);
		if (window.localStorage) {
			localStorage.setItem("SsApiJwt", token);
		}
		// set cookie
		var now = new Date();
		SetCookieExpMS(token, expireMS || now.getTime() + 3600, "SsApiJwt");
	}
};
export const ClearSsApiJwtToken = () => {
	_.config.Item("SsApiJwt", null);
	if (window.localStorage) {
		localStorage.removeItem("SsApiJwt");
	}
	RemoveCookie("SsApiJwt");
};
